import { Flex, Image } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
import logo from 'assets/img/logos/logo_fisiolab.png';

export function SidebarBrand() {
	return (
		<Flex alignItems='center' flexDirection='column'>
			<Image src={logo} alt='FisioLab' h='50px' my='24px' objectFit='contain' />
			<HSeparator mb='20px' />
		</Flex>
	);
}

export default SidebarBrand;
